import {
  Grid,
  GridItem,
  Image,
  Box,
  Button,
  Flex,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  useDisclosure,
  ModalBody,
  ModalCloseButton,
  useToast,
  Switch,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Tooltip,
  Input,
  Alert,
  AlertIcon,
  Stack,
} from '@chakra-ui/react';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import dayjs from 'dayjs';

import Collapsible from 'react-collapsible';

import xhr from 'xhr';
import HistorialTable from './components/historialTable';
import EnrollmentsTable from './components/enrollmentsTable';
import CareerTable from './components/careerTable';
import useSWR from 'swr';
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';
import Loading from 'components/loading/Loading';
import CourseTable from './components/courseTable';
import getInfoStudentAdviser from 'api/adviser';
import useAuth from 'hooks/useAuth';
import PagosTable from './Pagos/pagosTable';
import { channelLabel, howFoundLabel } from '../../prospectos/constants';
import ReferralsTab from 'components/referrals/ReferralsTab';
import { BRAND, InfoItem, PageHeader, SectionCard } from '../../components/ui';

function VerEstudianteAdviser() {
  const [adviserFetching, setAdviserFetching] = React.useState(false);

  let params = useParams();
  const id_est = params.id;
  const toasts = useToast();
  const { user } = useAuth();

  const { data, mutate } = useSWR({ id_est, type: 'getInfoStudentAdviser' }, getInfoStudentAdviser, {
    revalidateOnFocus: false,
  });

  const handleAdviser = async () => {
    try {
      setAdviserFetching(true);
      await xhr.put(`/students/${id_est}`, {
        data: { adviser: user.adviser.id },
      });

      mutate(
        {
          ...data,
          estudiante: { ...estudiante, adviser: { ...user.adviser } },
        },
        false
      );

      toasts({
        title: 'La información se actualizó correctamente!',
        position: 'bottom',
      });
    } catch (error) {
    } finally {
      setAdviserFetching(false);
    }
  };
  if (!data) return <Loading />;

  const { programTypes, affiliate, estudiante } = data;
  const studentUser = estudiante.user || {};
  const studentName = `${studentUser.first_name || ''} ${studentUser.last_name || ''}`.trim();
  const initials = `${(studentUser.first_name || ' ')[0]}${(studentUser.last_name || ' ')[0]}`.trim().toUpperCase();
  const birthdate = estudiante.birthdate || studentUser.birthdate;
  const origin = estudiante.origin_prospect;
  const adviserName = estudiante.adviser?.id
    ? `${estudiante.adviser.user?.first_name || ''} ${estudiante.adviser.user?.last_name || ''}`.trim()
    : null;
  const parentName =
    data.parent &&
    (data.parent.full_name || `${data.parent.user?.first_name || ''} ${data.parent.user?.last_name || ''}`.trim());

  const programBox = {
    border: '1px solid',
    borderColor: 'gray.200',
    borderRadius: 'md',
    bg: 'white',
    _hover: { borderColor: BRAND },
  };

  return (
    <Box>
      <PageHeader
        breadcrumb={[
          { label: 'Consultar estudiante', to: '/plataforma/asesoras/consultar-estudiante' },
          { label: 'Ver estudiante' },
        ]}
        title={studentName || `Estudiante ${id_est}`}
        subtitle={`Código ${id_est} · ${studentUser.email || 'Sin correo'}`}
        actions={
          <Button
            as={Link}
            to={`/plataforma/asesoras/ver-estudiante/${id_est}/modificar-estudiante`}
            size="sm"
            bg={BRAND}
            color="white"
            _hover={{ bg: '#463fd1' }}
          >
            Actualizar datos
          </Button>
        }
      />

      {estudiante.black_list && (
        <Alert status="error" borderRadius="md" mb={4}>
          <AlertIcon />
          Este estudiante está en la lista negra.
        </Alert>
      )}
      {estudiante.desease && (
        <Alert status="warning" borderRadius="md" mb={4}>
          <AlertIcon />
          Condición del estudiante: {estudiante.desease}
        </Alert>
      )}

      <Grid templateColumns={{ base: '1fr', xl: '320px minmax(0, 1fr)' }} gap={4} alignItems="start">
        <SectionCard>
          <Flex justify="center" mb={5}>
            {studentUser.image ? (
              <Image src={`${studentUser.image.url}`} boxSize="120px" objectFit="cover" borderRadius="full" alt={studentName} />
            ) : (
              <Flex
                bg="purple.50"
                color={BRAND}
                boxSize="96px"
                borderRadius="full"
                align="center"
                justify="center"
                fontWeight="700"
                fontSize="32px"
              >
                {initials}
              </Flex>
            )}
          </Flex>

          <Stack spacing={4}>
            <InfoItem label="Asesora">
              {adviserName || (
                <Button
                  size="sm"
                  variant="outline"
                  colorScheme="purple"
                  isLoading={adviserFetching}
                  onClick={handleAdviser}
                >
                  Asignarme estudiante
                </Button>
              )}
            </InfoItem>
            {origin?.id && (
              <InfoItem label="Origen">
                <Text as={Link} to={`/plataforma/asesoras/ver-prospecto/${origin.id}`} color={BRAND} fontWeight="600">
                  Prospecto #{origin.id}
                </Text>
                <Text fontSize="xs" color="gray.500" fontWeight="400">
                  {channelLabel(origin)}
                  {origin.how_found ? ` · ${howFoundLabel(origin.how_found, origin.how_found_detail)}` : ''}
                </Text>
              </InfoItem>
            )}
            <InfoItem label="Afiliado">
              {affiliate?.user ? `${affiliate.user.first_name || ''} ${affiliate.user.last_name || ''}`.trim() : null}
            </InfoItem>
            <InfoItem label="Categoría">{estudiante.user_from}</InfoItem>
            <InfoItem label="País">
              {studentUser.country
                ? `${studentUser.country.name}${studentUser.country.phone_code ? ` (+${studentUser.country.phone_code})` : ''}`
                : null}
            </InfoItem>
            <InfoItem label="Celular">{studentUser.cellphone}</InfoItem>
            <InfoItem label="SIMAT">{estudiante.simat || 'No está matriculado'}</InfoItem>
            <InfoItem label="Fecha de registro">
              {studentUser.createdAt ? dayjs(studentUser.createdAt).format('DD/MM/YYYY') : null}
            </InfoItem>
            <InfoItem label="Fecha de nacimiento">{birthdate ? dayjs(birthdate).format('DD/MM/YYYY') : null}</InfoItem>
            <InfoItem label="Último grado aprobado">{estudiante.last_approved_grade}</InfoItem>
            {data.parent && (
              <InfoItem label="Acudiente">
                <Text>{parentName}</Text>
                <Text fontSize="xs" color="gray.500" fontWeight="400">
                  {data.parent.home_phone || data.parent.user?.cellphone}
                  {' · '}
                  {data.parent.email || data.parent.user?.email}
                </Text>
              </InfoItem>
            )}
          </Stack>
        </SectionCard>

        <Stack spacing={4} minW={0}>
          <SectionCard title="Programas">
            {!programTypes[0] ? (
              <Text fontSize="sm" color="gray.500">
                Este estudiante no tiene programas matriculados. Matricúlalo en las pestañas Grados, Carreras Técnicas o
                Cursos.
              </Text>
            ) : (
              <Stack spacing={3} maxH="320px" overflowY="auto">
                {programTypes.map((programType) => {
                  const unique = programType.programs.filter(
                    (el, index, self) => self.findIndex((v) => v.id === el.id) === index
                  );
                  return (
                    <Box key={programType.id}>
                      <Collapsible
                        trigger={
                          <Flex {...programBox} cursor="pointer" px={4} py={3} justify="space-between" align="center">
                            <Text fontWeight="600" fontSize="sm">
                              {programType.name}
                            </Text>
                            <FaCaretDown color={BRAND} />
                          </Flex>
                        }
                      >
                        <Stack spacing={2} pl={6} pt={2}>
                          {unique.map((program) => (
                            <Collapsible
                              key={program.id}
                              trigger={
                                <Flex {...programBox} cursor="pointer" px={4} py={2} justify="space-between" align="center">
                                  <Text fontSize="sm">{program.name}</Text>
                                  <FaCaretDown />
                                </Flex>
                              }
                            >
                              <Box pl={6} pt={2}>
                                <Button
                                  as={Link}
                                  to={`/plataforma/asesoras/ver-estudiante/${id_est}/ver-resultados/${programType.slug}/${program.slug}`}
                                  size="xs"
                                  variant="outline"
                                  colorScheme="purple"
                                  rightIcon={<FaCaretRight />}
                                >
                                  Notas
                                </Button>
                              </Box>
                            </Collapsible>
                          ))}
                          <Button
                            as={Link}
                            to={`/plataforma/asesoras/ver-estudiante/${id_est}/ver-requisitos?program=${programType.id}`}
                            size="sm"
                            variant="outline"
                            colorScheme="purple"
                            alignSelf="flex-start"
                            rightIcon={<FaCaretRight />}
                          >
                            Requisitos
                          </Button>
                        </Stack>
                      </Collapsible>
                    </Box>
                  );
                })}
              </Stack>
            )}
          </SectionCard>

          <SectionCard padding={0}>
            <Tabs isLazy colorScheme="purple">
              <TabList px={5} pt={2} overflowX="auto" overflowY="hidden">
                <Tab fontWeight="500">Historial</Tab>
                <Tab fontWeight="500">Pagos</Tab>
                <Tab fontWeight="500">Grados</Tab>
                <Tab fontWeight="500">Carreras Técnicas</Tab>
                <Tab fontWeight="500">Cursos</Tab>
                <Tab fontWeight="500">Referidos</Tab>
              </TabList>

              <TabPanels>
                <TabPanel px={5} py={5}>
                  <HistorialTable />
                </TabPanel>
                <TabPanel px={5} py={5}>
                  <PagosTable />
                </TabPanel>
                <TabPanel px={5} py={5}>
                  <EnrollmentsTable />
                </TabPanel>
                <TabPanel px={5} py={5}>
                  <CareerTable />
                </TabPanel>
                <TabPanel px={5} py={5}>
                  <CourseTable />
                </TabPanel>
                <TabPanel px={5} py={5}>
                  <ReferralsTab studentId={id_est} basePath="/plataforma/asesoras/ver-estudiante" />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </SectionCard>
        </Stack>
      </Grid>
    </Box>
  );
}

export default VerEstudianteAdviser;
